import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';
import { SortFaqListDTO } from '@/api/DTO/information/faq.interface';

interface DndArticleListSectionProps {
	faqItems: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	faqItems,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = faqItems.find(
			(item: SortFaqListDTO) => item.id === active.id
		);
		const overItem = faqItems.find(
			(item: SortFaqListDTO) => item.id === over.id
		);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = faqItems.findIndex(
			(item: SortFaqListDTO) => item.id === active.id
		);
		const overIndex = faqItems.findIndex(
			(item: SortFaqListDTO) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={faqItems.map((i: { id: SortFaqListDTO }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>{t('faq.cn_title')}</StyledTableCell>
								<StyledTableCell>{t('faq.en_title')}</StyledTableCell>
								<StyledTableCell>{t('faq.qaCount')}</StyledTableCell>
								<StyledTableCell>{t('faq.lastUpdateTime')}</StyledTableCell>
								<StyledTableCell>{t('faq.createTime')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{faqItems?.map((item: SortFaqListDTO) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '230px',
});
